import React from 'react';

module.exports = React.createClass({
    render: function () {
        var paymentItems;
        var payments = this.props.data;
        if (payments && payments.length > 0) {
             var i = 0;
             paymentItems = payments.map(function (o) {
                return (<tr key={++i}>
                    <td style={{paddingLeft:0, paddingTop: "10px", paddingBottom: "10px"}}>
                        <i className={o.is_error ? "fa fa-exclamation-circle hc-red" : "fa fa-check-circle hc-green"}
                           style={{marginRight:'5px'}}/>
                        {o.date}
                    </td>
                    <td style={{paddingTop:"10px", paddingBottom:"10px"}}>{o.description}</td>
                    <td style={{textAlign:'right', paddingRight:0, paddingTop:"10px", paddingBottom: "10px"}}>{o.amount}</td>
                </tr>)
            });
        }

        return (
          <div>
              <span className="hc-f-l">{HC_LANG.PRO_PAYMENT_HISTORY}</span>
              <table className="table" style={{width:'100%', marginTop:'10px'}}>
                  <tbody>
                  {paymentItems}
                  <tr><td/><td/><td/></tr>
                  </tbody>
              </table>
          </div>
        )
    }
});


// WEBPACK FOOTER //
// ./payments/payments_table.js